import { Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IAppState } from '@myStore/app.state';
import { Store } from '@ngrx/store';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { isControlsIsValid } from '@shared/utils/formUtils';

@Component({
  selector: 'app-text-field-form',
  templateUrl: './text-field-form.component.html',
  styleUrls: ['./text-field-form.component.sass'],
})
export class TextFieldFormComponent implements OnInit {
  public loading$ = this._dialogRef.componentInstance.data.loading$;
  public fieldName = '';
  public form = new UntypedFormGroup({});
  public requiredErrorMessage = 'Поле является обазательным';

  constructor(
    private _store: Store<IAppState>,
    private _dialogRef: MatDialogRef<FormDialogComponent>
  ) {}

  ngOnInit(): void {
    if (this._dialogRef.componentInstance.data.fieldName) {
      this.fieldName = this._dialogRef.componentInstance.data.fieldName;

      this.form.addControl(
        this.fieldName,
        new UntypedFormControl(
          this._dialogRef.componentInstance.data.fieldValue || '',
          [Validators.required]
        )
      );
    }
  }

  onSubmit(): void {
    if (isControlsIsValid(this.form.controls)) {
      if (this._dialogRef.componentInstance.data.submit) {
        this._dialogRef.componentInstance.data.submit(this.form.value);
      }
    }
  }

  get field() {
    return this.form.get(this.fieldName);
  }

  onCancel(): void {
    this._dialogRef.close();
  }
}
